import { IonCard, IonCardContent, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import PersonIcon from '@material-ui/icons/Person';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getDate } from 'src/utils/helpers/referenceHelpers';
import { JobMessages } from '../../../intl/JobMessages';
import { DqText } from '../../dq-text';
import { Chip, ChipProps } from '../Chip';
import './MobileJobCard.scss';
import { syncCircleOutline, cloudOfflineOutline } from 'ionicons/icons';
import { useLimitedMode } from '../../../utils/auth/useLimitedMode';

interface MobileJobCardProps {
  /** The page to route to on select. */
  routerLink: string;
  /** The title of the card. */
  title: string;
  /** The name of the creator of the job. */
  createdByName: string;
  /** When the job was created. */
  createdAt: number;
  /** The timezone associated with the job. */
  timezone?: string;
  /** The text to display in the chip. */
  chipProps?: ChipProps;
  /** The size of the job log.  */
  linesParsed: number;
  /** Indicates the card represents a local job */
  isLocal: boolean;
}

const MobileJobCard: React.FC<MobileJobCardProps> = props => {
  const { isLimited } = useLimitedMode();

  return (
    <IonCard className="job-card" routerLink={props.routerLink}>
      <IonCardContent>
        <IonGrid>
          <IonRow>
            <IonCol size="6">
              <DqText variant="h3" color="dark">
                {props.title}
              </DqText>
            </IonCol>
            <IonCol>
              {props.isLocal && (
                <IonIcon
                  icon={isLimited ? cloudOfflineOutline : syncCircleOutline}
                  color="dark"
                  class="ion-padding-end"
                />
              )}
              {props.chipProps && <Chip title={props.chipProps.title} type={props.chipProps.type} />}
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <PersonIcon className="person-icon" height={15.5} width={15.5} />
              {/* TODO: Switch out with icon provided by Frankie when available*/}
              <DqText variant="body-small">{props.createdByName}</DqText>
            </IonCol>
            <IonCol>
              <IonGrid className="ion-no-padding">
                <IonRow className="ion-no-padding">
                  <IonCol className="ion-align-self-end">
                    <DqText variant="body-small">{getDate(props.createdAt, props.timezone)}</DqText>
                  </IonCol>
                </IonRow>
                <IonRow className="ion-no-padding">
                  <IonCol className="ion-align-self-end">
                    <DqText variant="body-small" style={{ textAlign: 'right' }}>
                      <FormattedMessage
                        {...JobMessages.jobCardLinesParsed}
                        values={{
                          linesParsed: props.linesParsed,
                        }}
                      />
                    </DqText>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  );
};

export default MobileJobCard;
